/* Product photo swipe adapter. Existing thumbnail handlers remain the source of truth. */
(() => {
  if (window.dlsGallerySwipe) return;
  window.dlsGallerySwipe = true;
  // Keep the native carousel available on touch tablets as well as phones.
  const style=document.createElement('style');
  style.textContent='@media (any-pointer:coarse){media-gallery.media-gallery--grid > slideshow-component{display:block!important}media-gallery.media-gallery--grid > .media-gallery__grid{display:none!important}}';
  style.textContent += `
    @media (min-width:750px){media-gallery.media-gallery--grid > slideshow-component{display:block!important}media-gallery.media-gallery--grid > .media-gallery__grid{display:none!important}}
    .dls-photo-arrows{position:absolute;pointer-events:none;z-index:3;display:none;align-items:center;justify-content:space-between;padding:0 10px;box-sizing:border-box}
    @media (min-width:750px) and (hover:hover){.dls-photo-arrows{display:flex}}
    .dls-photo-arrows[hidden]{display:none!important}
    .dls-photo-arrows button{pointer-events:auto;display:grid!important;place-items:center;width:42px!important;height:42px!important;min-height:42px!important;padding:0!important;margin:0!important;border:1px solid #d6cec3!important;border-radius:50%!important;background:rgba(255,255,255,.94)!important;color:#302b24!important;box-shadow:0 2px 9px #0002;cursor:pointer}
    .dls-photo-arrows button:hover{background:#f2eadf!important}
    .dls-photo-arrows button:focus-visible{outline:3px solid #805b38;outline-offset:3px}
    .dls-photo-arrows svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:2}
    media-gallery[data-dls-arrows] slideshow-arrows{display:none!important}
  `;
  document.head.append(style);
  function addArrows(root, surface, move) {
    if(getComputedStyle(root).position==='static')root.style.position='relative';
    const bar=document.createElement('div');bar.className='dls-photo-arrows';
    for(const [step,label,path] of [[-1,'Vorige productfoto','M14 5l-7 7 7 7'],[1,'Volgende productfoto','M10 5l7 7-7 7']]){
      const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',label);
      button.innerHTML=`<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${path}"/></svg>`;
      button.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();move(step);});bar.append(button);
    }
    root.append(bar);
    const position=()=>{const r=root.getBoundingClientRect(),b=surface.getBoundingClientRect();bar.hidden=!b.width||!b.height;bar.style.left=(b.left-r.left+root.scrollLeft)+'px';bar.style.top=(b.top-r.top+root.scrollTop)+'px';bar.style.width=b.width+'px';bar.style.height=b.height+'px';};
    const observer=new ResizeObserver(position);observer.observe(root);observer.observe(surface);
    surface.addEventListener('load',position);position();
  }
  const groups = [
    ['.dk-gallery', '.dk-photo', '[data-photo]'],
    ['.dz-gallery', '.dz-main img', '[data-photo]'],
    ['.dp-visual', '.sp-main,.ex-main,.ca-main,.dp-photo', '[data-photo],[data-gallery-thumb]'],
    ['.dls-medals__gallery', '.dls-medals__hero', '[data-image]']
  ];
  function bind() {
    document.querySelectorAll('media-gallery:not([data-dls-arrows])').forEach(root=>{
      const slides=root.querySelector('slideshow-component'),surface=slides?.querySelector('slideshow-container');
      if(!surface || slides.querySelectorAll('slideshow-slide').length<2)return;
      root.dataset.dlsArrows='true';
      addArrows(root,surface,step=>step>0?slides.next():slides.previous());
    });
    for (const [rootSelector, imageSelector, thumbSelector] of groups) {
      document.querySelectorAll(rootSelector).forEach(root => {
        const img = root.querySelector(imageSelector);
        if (!img || img.dataset.swipeReady || root.querySelectorAll(thumbSelector).length < 2) return;
        img.dataset.swipeReady = 'true';
        img.style.touchAction = 'pan-y pinch-zoom';
        img.style.userSelect = 'none';
        img.draggable = false;
        function move(step) {
          const thumbs=Array.from(root.querySelectorAll(thumbSelector));
          let index=thumbs.findIndex(b=>b.getAttribute('aria-pressed')==='true');
          if(index<0)index=0;
          const next=thumbs[(index+step+thumbs.length)%thumbs.length];
          next.click();
          const strip=next.parentElement, b=next.getBoundingClientRect(), s=strip.getBoundingClientRect();
          if(b.left<s.left)strip.scrollLeft-=s.left-b.left+8;
          else if(b.right>s.right)strip.scrollLeft+=b.right-s.right+8;
        }
        addArrows(root,img,move);
        let start = null, suppressUntil = 0;
        img.addEventListener('touchstart', e => {
          start = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
        }, {passive:true});
        img.addEventListener('touchmove', e => {
          if (!start || e.touches.length !== 1) { start = null; return; }
          const dx = e.touches[0].clientX-start.x, dy = e.touches[0].clientY-start.y;
          if (Math.abs(dy) > 18 && Math.abs(dy) > Math.abs(dx)) start = null;
        }, {passive:true});
        img.addEventListener('touchcancel', () => {start=null;}, {passive:true});
        img.addEventListener('touchend', e => {
          if (!start || e.touches.length || !e.changedTouches.length) { start=null; return; }
          const dx=e.changedTouches[0].clientX-start.x, dy=e.changedTouches[0].clientY-start.y;
          start=null;
          if (Math.abs(dx)<45 || Math.abs(dx)<Math.abs(dy)*1.4) return;
          suppressUntil=Date.now()+600;
          move(dx<0?1:-1);
        }, {passive:true});
        // A swipe must not activate the enclosing zoom button or link.
        root.addEventListener('click', e => {
          if(Date.now()<suppressUntil && (e.target===img || img.contains(e.target))) {
            e.preventDefault();e.stopImmediatePropagation();
          }
        }, true);
      });
    }
  }
  bind();
  let queued=false;
  new MutationObserver(() => {
    if(queued)return;queued=true;
    requestAnimationFrame(()=>{queued=false;bind();});
  }).observe(document.body,{childList:true,subtree:true});
})();
